import axios from "axios";


export const Resolution1604of2013Api = axios.create({
    baseURL: `${process.env.VUE_APP_URL}/api/documents/reports/1604/`
});